export enum Views {
  default = 'default',
  manageSettings = 'manageSettings',
  partnerSettings = 'partnerSettings',
  privacySettingsLink= 'privacySettingsLink'
}
